// extracted by mini-css-extract-plugin
export default {"container":"customerService_container__h08fJ","linksWrapper":"customerService_linksWrapper__-5ocS","linkWrapper":"customerService_linkWrapper__1ce70"};